<template>
  <div>
    <DataAuth></DataAuth>
  </div>
</template>

<script>
import DataAuth from '../components/DataAuth.vue';

export default {
  components: {
    DataAuth,
  },
};
</script>